import {HttpError} from './Http'

export type Editable<T> = Locked | Pending<T> | Loading<T> | Failure<T>

export interface Locked {
    readonly type: 'Locked'
}

export interface Pending<T> {
    readonly type: 'Pending'
    readonly value: T
}

export interface Loading<T> {
    readonly type: 'Loading'
    readonly value: T
}

export interface Failure<T> {
    readonly type: 'Failure'
    readonly value: T
    readonly error: HttpError
}

export function map<A, B>(fn: (value: A) => B, editable: Editable<A>): Editable<B> {
    switch (editable.type) {
        case 'Locked':
            return editable
        case 'Pending':
            return {
                type: 'Pending',
                value: fn(editable.value),
            }
        case 'Loading':
            return {
                type: 'Loading',
                value: fn(editable.value),
            }
        case 'Failure':
            return {
                type: 'Failure',
                value: fn(editable.value),
                error: editable.error,
            }
    }
}

export function inputsDisabled<T>(editable: Editable<T>): boolean {
    return editable.type === 'Locked' || editable.type === 'Loading'
}

export function withDefault<T>(defaultValue: T, editable: Editable<T>): T {
    return editable.type !== 'Locked' ? editable.value : defaultValue
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/Editable.ts